import { connectDeep } from 'redux-utils';

import i18n from 'i18n';

import App from 'models/app';
import AppList from 'components/AppList';
import ClockList from 'components/ClockList';
import Collection from 'components/Collection';

import { fetchCollection } from 'actions/registry';

const APP_DIGEST_PROPS = {
  showInstalled: true
};

const mapStateToProps = (state, { isApp, payload: { id } = {} }) => {
  const {
    collections,
    features: { flags },
    fetchCollection: { loading: fetchCollectionLoading },
    installed: {
      entries: installedEntries = [],
      error,
      loading: installedLoading
    }
  } = state.registry;

  const collection = collections[id] || {};
  const showSearch = flags ? flags.showSearch : false;
  const loading =
    (installedEntries.length > 0 ? false : installedLoading) ||
    fetchCollectionLoading;
  const apps = collection.appIds
    ? collection.appIds.map((appId) => App.selectFromState(appId, state))
    : [];
  const backText = i18n(
    `page.${isApp ? 'App' : 'Clock'}.Navigation.backText`
  )();
  const ListPage = isApp ? AppList : ClockList;

  return {
    appDigestProps: APP_DIGEST_PROPS,
    apps,
    backText,
    collection,
    hasNextPage: collection.hasNextPage,
    error,
    loading,
    ListPage,
    showSearch
  };
};

const mapDispatchToProps = {
  fetchMore: fetchCollection
};

export default connectDeep(mapStateToProps, mapDispatchToProps)(Collection);
